import { render, staticRenderFns } from "./NewThreadModal.vue?vue&type=template&id=306c4fba&"
import script from "./NewThreadModal.vue?vue&type=script&lang=js&"
export * from "./NewThreadModal.vue?vue&type=script&lang=js&"
import style0 from "./NewThreadModal.vue?vue&type=style&index=0&id=306c4fba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports